import React from "react";

export const Calendar = ({ color = "black", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
      style={{ color }}
    >
      <g id="famicons:calendar-clear-outline">
        <path
          id="Vector"
          d="M20 3.75H5C3.75736 3.75 2.75 4.75736 2.75 6V19.5C2.75 20.7426 3.75736 21.75 5 21.75H20C21.2426 21.75 22.25 20.7426 22.25 19.5V6C22.25 4.75736 21.2426 3.75 20 3.75Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M6.5 2.25V3.75M18.5 2.25V3.75M22.25 7.5H2.75"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
